// This is the client's API it uses for interacting with the `server`.

import { SERVER_API_PATH, serverApi } from "./api-server-actions";

export const serverCheckMigrationStatus = async (): Promise<{
  has_unapplied_migrations: boolean;
  count: number;
}> => {
  const response = await serverApi.get(`${SERVER_API_PATH}/tooling/migration-status/`);
  return response.data;
};

export const serverRunMigrations = async (): Promise<{ success: boolean; message: string }> => {
  const response = await serverApi.post(`${SERVER_API_PATH}/tooling/migration-status/`);
  return response.data;
};
